import React, { useEffect, useState } from "react";
import TopBlog from "../TopBlog/TopBlog";

const SELECTED_PATHS = [
  "i-built-cursor-for-spreadsheets-but-what-for-364e",
  "can-i-show-pie-charts-on-my-website-introducing-recharts-55p",
  "wanna-create-your-own-version-of-messenger-learn-setting-up-socketio-3lkj",
];

const NOTE_EXCERPTS = {
  "i-built-cursor-for-spreadsheets-but-what-for-364e":
    "Undo, provenance, latency, and the gap between a demo and something someone trusts with their numbers.",
  "can-i-show-pie-charts-on-my-website-introducing-recharts-55p":
    "Recharts, accessibility, and the small decisions that keep dashboards honest.",
  "wanna-create-your-own-version-of-messenger-learn-setting-up-socketio-3lkj":
    "Rooms, reconnects, and why your first realtime feature should be boring on purpose.",
};

function excerptFor(blog) {
  if (!blog?.canonical_url) return "";
  const slug = blog.canonical_url.split("/").filter(Boolean).pop() || "";
  return NOTE_EXCERPTS[slug] || blog.description || "";
}

const TopBlogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    fetch("https://dev.to/api/articles?username=hzahar")
      .then((res) => res.json())
      .then((data) => {
        const ordered = [];
        SELECTED_PATHS.forEach((slug) => {
          const found = data.find((a) => {
            const s = a.canonical_url?.split("/").filter(Boolean).pop();
            return s === slug;
          });
          if (found) ordered.push(found);
        });
        setBlogs(ordered);
      })
      .catch(() => setBlogs([]))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <section id="blogs" className="notes" data-aos="fade-up">
      <div className="notes__inner">
        <h2 className="notes__title">Notes</h2>
        <p className="notes__subtitle">
          Occasional essays—mostly for people who ship.
        </p>
        {isLoading
          ? [0, 1, 2].map((item) => (
              <article key={item} className="notes__entry notes__entry--skeleton">
                <div className="notes__sk-line notes__sk-line--title" />
                <div className="notes__sk-line notes__sk-line--excerpt" />
                <div className="notes__sk-line notes__sk-line--excerpt notes__sk-line--short" />
                <div className="notes__sk-line notes__sk-line--meta" />
              </article>
            ))
          : blogs.map((blog) => (
              <TopBlog key={blog.id} blog={blog} excerpt={excerptFor(blog)} />
            ))}
        <div className="notes__foot">
          <a
            href="https://dev.to/hzahar"
            target="_blank"
            rel="noreferrer"
          >
            More on hzahar @ dev.to
          </a>
        </div>
      </div>
    </section>
  );
};

export default TopBlogs;
